module.exports = __webpack_public_path__ + "static/media/teamwork.ceb01c9f.png";